module.exports = __webpack_public_path__ + "static/media/female_front.71397df6.jpg";